<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate"
                          v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>

            <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchChallan"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button v-if="this.salesChallanList.length > 0" @click.prevent="reset"
                      class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()"
               v-if="this.salesChallanList.length > 0 && this.$store.getters.modules.includes('5.38')" >
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>

            <DataTable :value="salesChallanLists"
                       :paginator="true" ref="po"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id"
                       :selection.sync="selectedProduct1" selectionMode="single">
              <Column header="S.N" field=""/>
              <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']"/>
                </template>
              </Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']"/>
                </template>
              </Column>
              <Column header="Challan No" :sortable="true" field="challanNo" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['challanNo']"/>
                </template>
              </Column>
              <Column header="Supplier" :sortable="true" field="accountName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
                </template>
                <template #footer>
           Total:
         </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>
              <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']"/>
                </template>
              </Column>
              <Column header="Sub Total" bodyStyle="text-align: right" :sortable="true" field="subTotalAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['subTotalAmount']"/>
                </template>
                <template #footer>
            {{totalSubAmount.toFixed(2)}}
          </template>
              </Column>
              <Column header="Non-taxable" bodyStyle="text-align: right" :sortable="true" field="nonTaxableAmount"
                      filterMatchMode="contains">

                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['nonTaxableAmount']"/>
                </template>

                <template #footer>
            {{totalNonTaxableAmount.toFixed(2)}}
          </template>

              </Column>
              <Column header="Taxable" bodyStyle="text-align: right" :sortable="true" field="taxableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['taxableAmount']"/>
                </template>
          <template #footer>
            {{totalTaxableAmount.toFixed(2)}}
          </template>
              </Column>
              <Column header="Vat" bodyStyle="text-align: right" field="vatAmount" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['vatAmount']"/>
                </template>
                <template #footer>
            {{totalVatAmount.toFixed(2)}}
          </template>
              </Column>
              <Column header="Total" bodyStyle="text-align: right" :sortable="true" field="totalBillAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']"/>
                </template>
                <template #footer>
            {{totalSumBillAmount.toFixed(2)}}
          </template>
              </Column>
              <Column header="Org Name" :sortable="true" field="organisationName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['organisationName']"/>
                </template>
              </Column>
              <Column header="Action" headerStyle="width:12em">
                <template #body="slotProps">
                  <Button icon="pi pi-pencil" v-if="enableEdit" v-tooltip.top="'Edit'"
                          class="p-button-raised p-button-success"
                          @click="editSalesChallan(slotProps.data)"/>
                  <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success" v-tooltip.top="'Edit'"
                          @click="editSalesChallan(slotProps.data)"/>
                  <Button icon="pi pi-trash" v-if="enableDelete"   v-tooltip.top="'Delete'"
                          class="p-button-raised p-button-danger "
                          @click="openDialog(slotProps.data.id)"/>
                  <Button icon="pi pi-trash" v-else disabled class="p-button-raised p-button-danger"  v-tooltip.top="'Delete'"
                          @click="openDialog(slotProps.data.id)"/>

                  <Button icon="pi pi-eye" class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                          @click="viewPIVDetail(slotProps.data)"/>
                  <Button icon="pi pi-print" class="p-button-raised"  v-tooltip.top="'Print'"
                          @click="exportToPdf(slotProps.data.id)"/>
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'

export default {
  name: 'salesChallanReport',
  props: ['status'],
  data() {
    return {
      fromDate: null,
      toDate: null,
      salesChallanList: [],
      loading: false,
      dialogShow: false,
      selectedProduct1: null,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      enableEdit: false,
      enableDelete: false,
      totalSubAmount: 0,
      totalNonTaxableAmount: 0,
      totalTaxableAmount: 0,
      totalVatAmount: 0,
      totalSumBillAmount: 0
    }
  },
  computed: {
    salesChallanLists() {
      return this.$store.state.sales.salesChallanLists
    }
  },
  mounted() {
    if (this.status !== undefined) {
      this.$toast.add({severity: 'success', summary: '', detail: this.status.message, life: 3000})
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  methods: {
    async searchChallan() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadSalesChallanLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 3000})
      } else {
        this.salesChallanList = resp.data.data
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
        this.totalBalance()
      }
    },
    async viewPIVDetail(data) {
      console.log(data)
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        salesDate: data.purchaseSalesDateNepali,
        challanNo: data.challanNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        vatTypeEnum: data.vatTypeEnum,
        remarks: data.remarks
      }
      console.log(PIHdata)
      this.$router.push({name: 'sales Detail Report', params: {salesHeaderObj: PIHdata}})
    },
    totalBalance() {
      this.totalSubAmount = 0.0
      this.totalNonTaxableAmount = 0.0
      this.totalTaxableAmount = 0.0
      this.totalVatAmount = 0.0
      this.totalSumBillAmount = 0.0
      for (let sale of this.salesChallanList) {
        this.totalSubAmount += sale.subTotalAmount
        this.totalNonTaxableAmount += sale.nonTaxableAmount
        this.totalTaxableAmount += sale.taxableAmount
        this.totalVatAmount += sale.vatAmount
        this.totalSumBillAmount += sale.totalBillAmount
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesChallan' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'salesChallan.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/SalesChallan' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesChallan.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    editSalesChallan(data) {
      this.$router.push({name: 'Sales Challan', params: {salesChallan: data}})
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.08')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 3000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSalesChallan', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 3000})
      }
      this.dialogShow = false
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    reset() {
      this.salesChallanList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    InputMask
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// salesChallanReport.vue?4dbc88ca